<template>
  <div>
    <div class="quicknav">
      <div
        class="qnlist"
        v-for="(nav, index) in navs"
        :key="index"
        :class="{ qnactive: nav.isactive }"
        @mouseover="nav.isactive = true"
        @mouseleave="nav.isactive = currentnav == index"
        @click="scrollto(nav.navid)"
      >
        {{ nav.isactive ? nav.name : '' }}
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img src="/static/img/p1.jpg" width="100%" alt="Blueshark R1" />
      </div>
      <div class="text t1">
        <div
          class="fs_big fw_bold color_theme t1_1 aniel"
          :class="{ ani: ani.a1 }"
        >
          Blueshark R1
        </div>
        <div class="fs_big fw_bold t1_2 aniel" :class="{ ani1: ani.a1 }">
          Smart Electric Scooter
        </div>
        <div class="color_gray aniel" :class="{ ani2: ani.a1 }">
          SMART is the new POWER.
        </div>
        <div
          class="btn fs_sub t1_6 color_theme aniel"
          :class="{ ani2: ani.a1 }"
          @click="checkconfig"
        >
          Configuration Comparison
        </div>
      </div>
      <div class="text t1a" id="a2">
        <div>
          <span :class="{ aniel: true, ani: ani.a2 }">
            <span class="fs_middle">110 </span>km </span
          ><br />
          <span class="fs_tiny color_gray aniel" :class="{ ani1: ani.a2 }">
            NEDC Range
          </span>
        </div>
        <div>
          <span :class="{ aniel: true, ani: ani.a2 }"
            ><span class="fs_middle">80 </span>km / h</span
          ><br />
          <span class="fs_tiny color_gray aniel" :class="{ ani1: ani.a2 }"
            >Top Speed</span
          >
        </div>
        <div>
          <span :class="{ aniel: true, ani: ani.a2 }">
            <span class="fs_normal fw_bold">
              Power & System Domain Controllers
            </span>
          </span>
          <br />
          <span class="fs_tiny color_gray aniel" :class="{ ani1: ani.a2 }">
            Smart Central Control System
          </span>
        </div>
        <div>
          <span :class="{ aniel: true, ani: ani.a2 }">
            <span class="fs_normal fw_bold">ArkRide</span>
            <span class="fs_normal">OS 2.0</span>
          </span>
          <br />
          <span class="fs_tiny color_gray aniel" :class="{ ani1: ani.a2 }">
            Blueshark Smart Operating System
          </span>
        </div>
      </div>
    </div>
    <div class="page" id="n1" v-show="false">
      <div class="pic">
        <img
          src="/static/img/p2.jpg"
          width="100%"
          alt="Blueshark R1 Smart Electric Motocycle"
        />
      </div>
      <div class="text t2" id="a3">
        <div class="title fs_big fw_bold aniel" :class="{ ani: ani.a3 }">
          blueshark R1
        </div>
        <div class="fs_content content aniel" :class="{ ani1: ani.a3 }">
          The Smart Electric Motorcycle Created with<br />Automotive Technology
        </div>
      </div>
    </div>
    <div class="page" id="n2">
      <swiper3 ref="swiper3"></swiper3>
    </div>
    <div class="page" id="s4">
      <swiper4></swiper4>
      <div class="text t4" id="a4">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a4 }">
          Double Hydraulic Disc Brakes with CBS
        </div>
        <div class="fs_tiny content t4_2 aniel" :class="{ ani1: ani.a4 }">
          The Blueshark R1 is equipped with double hydraulic disc brakes, along
          with a combination braking system, allowing both wheels to bear
          braking force simultaneously no matter which brake lever you pull.
          Stop right where you are!
        </div>
      </div>
    </div>
    <div class="page" id="n3">
      <div class="pic">
        <img
          src="/static/img/p5.jpg"
          width="100%"
          alt="Blueshark R1 electric motor controller"
        />
      </div>
      <div class="text t5" id="a5">
        <div class="fs_big1 fw_bold t5_1 aniel" :class="{ ani: ani.a5 }">
          Steer at Will
        </div>
        <div class="fs_sub color_gray t5_2 aniel" :class="{ ani1: ani.a5 }">
          Electric Motor Controller
        </div>
        <div class="fs_tiny content1 aniel" :class="{ ani2: ani.a5 }">
          The Blueshark R1 rocks a high-power FOC electric motor controller,
          empowering our riders to steer smooth as silk. Through its advanced
          architecture, low power consumption, light weight and solid build, our
          motor controller reflects the quality and standards of the automotive
          industry.
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p6.jpg"
          width="100%"
          alt="Blueshark 6 Driving Modes"
        />
      </div>
      <div class="text t6" id="a6">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a6 }">
          5 Driving Modes
        </div>
        <div class="fs_tiny content aniel" :class="{ ani1: ani.a6 }">
          With the tuning of the controller, the Blueshark R1 support 5 driving
          modes,<br />
          including 3 Regular Driving Modes,<br />
          the Move Assist Mode and the Turbo Racing Mode*.
        </div>
      </div>
      <div class="text t6a" id="a32">
        <div class="fs_tiny color_gray aniel" :class="{ ani: ani.a32 }">
          *Available only with both of the battery packs working simultaneously
        </div>
      </div>
    </div>
    <div class="page" id="n4">
      <div class="pic">
        <img
          src="/static/img/p7.jpg"
          width="100%"
          alt="Blueshark dual lithium battery packs"
        />
      </div>
      <div class="text t7" id="a7">
        <div class="t7_left">
          <div class="fs_big1 fw_bold t7_1 aniel" :class="{ ani: ani.a7 }">
            Juice All Week
          </div>
          <div class="fs_sub color_gray t7_2 aniel" :class="{ ani1: ani.a7 }">
            Dual Lithium-Ion Battery Packs
          </div>
          <div class="fs_tiny content1 aniel" :class="{ ani2: ani.a7 }">
            Two automobile class lithium-ion battery packs are loaded in the
            trunk of the Blueshark R1. Under regular driving conditions, you’ll
            have 110 kilometers of NEDC range, adequate for a whole week of
            urban commuting.
          </div>
        </div>
        <div class="t7_right">
          <div class="t7_3 aniel" :class="{ ani: ani.a7 }">
            <span class="fs_middle">2,880 </span>Wh<br /><span
              class="fs_tiny color_gray"
              >Dual-Battery Capacity</span
            >
          </div>
          <div class="t7_3 aniel" :class="{ ani1: ani.a7 }">
            <span class="fs_middle">110 </span>km<br />
            <span class="fs_tiny color_gray">
              NEDC Range
            </span>
          </div>
          <div class="aniel" :class="{ ani2: ani.a7 }">
            <span class="fs_middle">&lt; 3.5 </span>h<br />
            <span class="fs_tiny color_gray">
              Charging from 0-100%
            </span>
          </div>
        </div>
      </div>
      <div id="a8" class="text t7a">
        <!-- <div class="fs_tiny aniel" :class="{ani: ani.a8}">*With a 75 kg passenger, 25 degrees Celcius and a driving speed of 30 km/h</div> -->
      </div>
    </div>
    <div class="page">
      <div class="t8">
        <div
          id="a9"
          class="title fs_middle fw_bold aniel"
          :class="{ ani: ani.a9 }"
        >
          Battery Management System
        </div>
        <div class="t8a">
          <div>
            <div id="a10" class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img src="/static/img/p8-11.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a10 }"
                >Pre-discharging</span
              >
            </div>
            <div id="a11" class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img src="/static/img/p8-21.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a11 }"
                >Strong / Weak Electricity<br />Isolation</span
              >
            </div>
            <div id="a12" class="fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img src="/static/img/p8-31.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a12 }"
                >Overcharge Protection</span
              >
            </div>
          </div>
          <div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img src="/static/img/p8-12.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a10 }"
                >Voltage Balance</span
              >
            </div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img src="/static/img/p8-22.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a11 }"
                >Waterproof</span
              >
            </div>
            <div class="fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img src="/static/img/p8-32.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a12 }"
                >Over-discharge Protection</span
              >
            </div>
          </div>
          <div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img src="/static/img/p8-13.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a10 }"
                >Charging Cycle Count</span
              >
            </div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img src="/static/img/p8-23.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a11 }"
                >Open-circuit Protection</span
              >
            </div>
            <div class="fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img src="/static/img/p8-33.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a12 }"
                >Optical Communication</span
              >
            </div>
          </div>
          <div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img src="/static/img/p8-14.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a10 }"
                >Dual-battery Discharge<br />Management</span
              >
            </div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img src="/static/img/p8-24.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a11 }"
                >Short-circuit Protection</span
              >
            </div>
            <div class="fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img src="/static/img/p8-34.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a12 }"
                >Secondary Protection of<br />Battery Failures</span
              >
            </div>
          </div>
          <div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img src="/static/img/p8-15.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a10 }"
                >Dual-battery Charging<br />Management</span
              >
            </div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img src="/static/img/p8-25.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a11 }"
                >Overcurrent Protection</span
              >
            </div>
            <div class="fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img src="/static/img/p8-35.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a12 }"
                >Overheat Protection</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p9.jpg"
          width="100%"
          alt="Blueshark turbo boost mode"
        />
      </div>
      <div class="text normalt" id="a13">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a13 }">
          Turbo Boost Mode
        </div>
        <div class="fs_tiny aniel" :class="{ ani1: ani.a13 }">
          We have independently developed a technique that automatically
          switches between a series and parallel connection among multiple
          batteries. You will get a longer range with a<br />parallel
          connection, while Turbo Boost Mode* can be activated with a series
          connection. This technology is a prominent breakthrough in BMS.
        </div>
      </div>
      <div class="text t9a" id="a31">
        <div class="fs_tiny color_gray aniel" :class="{ ani: ani.a31 }">
          *Available only with both of the battery packs working simultaneously
        </div>
      </div>
    </div>
    <div class="page">
      <swiper10></swiper10>
      <div class="text normalt" id="a14">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a14 }">
          Multi-Scenario Flash Charge
        </div>
        <div class="fs_tiny content aniel" :class="{ ani1: ani.a14 }">
          As long as there is electricity, there is a way of charging the
          Blueshark R1. It only takes 2.5 hours to charge from 0% to 80%, and
          can<br />be fully charged within 3.5 hours.
        </div>
      </div>
    </div>
    <div class="page" id="n5">
      <swiper11></swiper11>
      <div class="text t11" id="a15">
        <div class="title fs_big1 fw_bold aniel" :class="{ ani: ani.a15 }">
          Designed with Disciplined<br />Passion
        </div>
      </div>
    </div>
    <div class="page" id="n6">
      <div class="pic">
        <img src="/static/img/p12.jpg" width="100%" alt="" />
      </div>
      <div class="text normalt" id="a16">
        <div class="title fs_big1 fw_bold aniel" :class="{ ani: ani.a16 }">
          Craftsmanship Trumps Everything
        </div>
      </div>
      <div class="text t12">
        <div class="fs_tiny">
          Manufactured in the A-list motorcycle factories
        </div>
        <div class="fs_tiny t12_2">Top Class Supply Chain Partners</div>
        <div class="fs_tiny">200 kg Carrying Capacity</div>
      </div>
    </div>
    <div class="page" id="n7">
      <div class="pic">
        <img
          src="/static/img/p13.jpg"
          width="100%"
          alt="Blueshark automotive technology"
        />
      </div>
      <div class="text normalt" id="a17">
        <div class="title fs_big1 fw_bold aniel" :class="{ ani: ani.a17 }">
          Automotive Technology
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p14.jpg"
          width="100%"
          alt="Blueshark dual ECUs + CAN bus"
        />
      </div>
      <div class="text normalt" id="a18">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a18 }">
          Power & System Domain Controllers
        </div>
        <div class="fs_tiny content aniel" :class="{ ani1: ani.a18 }">
          The system domain controller connects to the Blueshark’s IoV system
          via a 2G/4G communication module, while the other monitors and adjusts
          the driving status in real time. Both of the domain controllers can<br />work
          independently or connect as a unit through the CAN bus.
        </div>
      </div>
    </div>
    <div class="page">
      <swiper15></swiper15>
      <div class="text normalt" id="a19">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a19 }">
          10" Full-Color HD IPS Panel Display
        </div>
        <div class="fs_tiny content aniel" :class="{ ani1: ani.a19 }">
          Blueshark R1 rocks a 10" full color HD IPS screen manufactured from
          G+G full-lamination technology. <br />
          It supports GPS/Beidou/4G positioning, Bluetooth navigation, Bluetooth
          music playback, driving recorder, OTA updates, etc., bringing about
          intuitive and intelligent interaction for users.
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p16.jpg"
          width="100%"
          alt="Blueshark R1 AI range estimation"
        />
      </div>
      <div class="text normalt" id="a20">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a20 }">
          AI Range Estimation
        </div>
        <div class="fs_tiny content aniel" :class="{ ani1: ani.a20 }">
          Combining parameters like remaining battery capacity, environmental
          temperature, total weight, etc., the Blueshark R1 intelligently<br />calculates
          the remaining battery range.
        </div>
      </div>
    </div>
    <div class="page">
      <div class="lisablack" id="a21">
        <!-- <div class="title fs_middle fw_bold aniel" :class="{ani: ani.a21}">“Hello, Lisa.”</div>
        <div class="fs_tiny content aniel" :class="{ani1: ani.a21}">Say hello to your AI driving companion Lisa. Your ride will never be lonely with her company.</div> -->
      </div>
      <div class="pic">
        <!-- <video src="/static/img/lisa.mp4" width="100%" autoplay="autoplay" loop="loop" muted="muted"></video> -->
      </div>
    </div>
    <!-- <div class="page">
      <div class="lisablack" id="a21">
        <div class="title fs_middle fw_bold aniel" :class="{ani: ani.a21}">“Hello, Lisa.”</div>
        <div class="fs_tiny content aniel" :class="{ani1: ani.a21}">Say hello to your AI driving companion Lisa. Your ride will never be lonely with her company.</div>
      </div>
      <div class="pic">
        <video src="/static/img/lisa.mp4" width="100%" autoplay="autoplay" loop="loop" muted="muted"></video>
      </div>
    </div> -->
    <div class="page">
      <div class="pic">
        <img src="/static/img/en17.jpg" width="100%" alt="Blueshark APP" />
      </div>
      <div class="text normalt" id="a22">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a22 }">
          Blueshark APP
        </div>
        <div class="fs_tiny content aniel" :class="{ ani1: ani.a22 }">
          The Blueshark R1 interacts with the IoV system in real time, and
          messages are synchronized to the Blueshark App on your smartphone.
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p18.jpg"
          width="100%"
          alt="Blueshark R1 with 74 sensors"
        />
      </div>
      <div class="text normalt" id="a23">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a23 }">
          70+ Sensors
        </div>
        <div class="fs_tiny content aniel" :class="{ ani1: ani.a23 }">
          A total of 70+ sensors are spread all over the body of the Blueshark
          R1, collecting information such as speed, acceleration,<br />temperature,
          environmental lighting, seat pressure, etc.
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p19.jpg"
          width="100%"
          alt="Blueshark R1 helping boost mode"
        />
      </div>
      <div class="text normalt" id="a24">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a24 }">
          Move Assist Mode (MAM)
        </div>
        <div class="fs_tiny content aniel" :class="{ ani1: ani.a24 }">
          With the Move Assist Mode activated, when you rotate the handlebar or
          move the gear button to the left, a helping force is given to move the
          R1 forward at the walking speed;<br />
          when you move the gear button to the right, a helping force is given
          to move the R1 backward slowly, making movement of R1 easier and more
          convenient.
        </div>
      </div>
    </div>
    <div class="page">
      <swiper20></swiper20>
      <div class="text normalt" id="a25">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a25 }">
          Advanced Driver-Assistance Systems
        </div>
        <div class="fs_tiny content aniel" :class="{ ani1: ani.a25 }">
          ADAS records the driving process. Images and notices are shown on the
          display attached to the handlebars in real time.
        </div>
      </div>
    </div>
    <div class="page" id="n8">
      <swiper21></swiper21>
      <div class="text normalt" id="a26">
        <div class="title fs_big1 fw_bold aniel" :class="{ ani: ani.a26 }">
          Safety Matters
        </div>
        <div class="fs_tiny content aniel" :class="{ ani1: ani.a26 }">
          Through your smartphone or Bluetooth remote control, you can
          automatically ungurad and unlock the vehicle when approaching, <br />
          and guard and lock the vehicle when getting away. The whole operation
          process is intuitive without additional action.
        </div>
      </div>
    </div>
    <div class="page">
      <swiper22></swiper22>
    </div>
    <div class="page">
      <swiper23></swiper23>
    </div>
    <div class="page p24">
      <div id="a27">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a27 }">
          Specs & Features
        </div>
        <div class="t24p aniel" :class="{ ani1: ani.a27 }">
          <div>
            <img
              src="/static/img/p24-1-en.png"
              width="100%"
              alt="Blueshark R1 specs and features"
            />
          </div>
        </div>
        <div class="t24">
          <div class="feature" id="a28">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                Rated Load Capacity
              </span>
              <br />
              <span class="fs_tiny aniel" :class="{ ani1: ani.a28 }">
                200 kg
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                Weight (with Battery)
              </span>
              <br />
              <span class="fs_tiny aniel" :class="{ ani1: ani.a28 }">
                115 kg
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                Colors
              </span>
              <br />
              <span class="fs_tiny aniel" :class="{ ani1: ani.a28 }">
                Spindrift White<br />Deepsea Black<br />Blueshark Blue<br />Pine
                Green<br />Coconut Brown
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                Starting Ignition
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a28 }">
                Bluetooth Sensing
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                Panel Screen
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a28 }">
                10'' Full Color HD IPS Screen
              </span>
            </div>
          </div>
          <div class="feature" id="a29">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                Smart Operating System
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a29 }">
                ArkRide OS
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                Battery Capacity
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a29 }">
                1,440*2 Wh
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                NEDC Range
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a29 }">
                110 km
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                Top Speed
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a29 }">
                80 km/h
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                Peak Power
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a29 }">
                5,000 W
              </span>
            </div>
          </div>
          <div class="feature" id="a30">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }"
                >Max Rotational Speed</span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a30 }"
                >5,500 rpm</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }"
                >Smart Central Control System</span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a30 }"
                >Power & System Domain Controllers</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }"
                >ADAS (Advanced<br />Driver-assistance System)</span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a30 }"
                >Rear Camera + Dual Ultrasonic Sensors<br />(Frontal Camera
                Optional)
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }"
                >Braking System</span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a30 }"
                >Front & Rear Disc Brakes<br />with CBS<br />(Combined Braking
                System)</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span
                class="fs_tiny color_gray aniel"
                :class="{ ani: ani.a30 }"
              ></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a30 }"
                ><br
              /></span>
            </div>
            <!-- <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ani: ani.a30}">Voice Assistant</span><br/><span class="fs_tiny aniel" :class="{ani1: ani.a30}">Smart Driving<br/>Companion "Lisa"</span></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swiper3 from '../swiper_en/swiper3'
import swiper4 from '../swiper_en/swiper4'
import swiper10 from '../swiper_en/swiper10'
import swiper11 from '../swiper_en/swiper11'
import swiper15 from '../swiper_en/swiper15'
import swiper20 from '../swiper_en/swiper20'
import swiper21 from '../swiper_en/swiper21'
import swiper22 from '../swiper_en/swiper22'
import swiper23 from '../swiper_en/swiper23'
import { throttle } from 'lodash'
export default {
  data() {
    return {
      ani: {
        a1: false,
        a2: false,
        a3: false,
        a4: false,
        a5: false,
        a6: false,
        a7: false,
        a8: false,
        a9: false,
        a10: false,
        a11: false,
        a12: false,
        a13: false,
        a14: false,
        a15: false,
        a16: false,
        a17: false,
        a18: false,
        a19: false,
        a20: false,
        a21: false,
        a22: false,
        a23: false,
        a24: false,
        a25: false,
        a26: false,
        a27: false,
        a28: false,
        a29: false,
        a30: false,
        a31: false,
        a32: false
      },
      navs: [
        { name: 'R1', isactive: false, navid: 'n1' },
        { name: 'Performance', isactive: false, navid: 'n2' },
        { name: 'Pilot', isactive: false, navid: 'n3' },
        { name: 'Range', isactive: false, navid: 'n4' },
        { name: 'Design', isactive: false, navid: 'n5' },
        { name: 'Quality', isactive: false, navid: 'n6' },
        { name: 'Smart', isactive: false, navid: 'n7' },
        { name: 'Safety', isactive: false, navid: 'n8' }
      ],
      currentnav: -1
      // aniarr: ["a1","a2","a3"]
    }
  },
  components: {
    swiper3,
    swiper4,
    swiper10,
    swiper11,
    swiper15,
    swiper20,
    swiper21,
    swiper22,
    swiper23
  },
  mounted() {
    window.scrollTo(0, 0)
    this.$nextTick(() => {
      window.addEventListener(
        'scroll',
        throttle(this.animateTxt, 500, { leading: true })
      )
    })
    setTimeout(() => {
      this.ani.a1 = true
    }, 300)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.animateTxt)
  },
  methods: {
    getscrolltop(id) {
      let obj = document.getElementById(id)
      if (obj) {
        let top = obj.offsetTop
        while ((obj = obj.offsetParent)) {
          top += obj.offsetTop
        }
        return top
      }
    },
    scrollto(id) {
      window.scrollTo(0, this.getscrolltop(id))
    },
    setnavs() {
      for (let i in this.navs) {
        this.navs[i].isactive = false
      }
    },
    checkconfig() {
      this.$router.push('/en/R1config')
    },
    animateTxt() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      // let width = document.body.clientWidth
      let height = document.body.clientHeight
      if (top <= 100) {
        this.$emit('hidenav')
      } else {
        this.$emit('shownav')
      }
      // 左侧快速导航
      for (let i = 0; i < 9; i++) {
        let prev = i > 0 ? this.getscrolltop('n' + i) : 0
        let next = i < 8 ? this.getscrolltop('n' + (i + 1)) : 1000000
        if (top >= prev && top < next) {
          this.setnavs()
          if (i > 0) {
            this.navs[i - 1].isactive = true
          }
          this.currentnav = i - 1 // 锁定当前页
          break
        }
      }
      // 每一页文字出现特效
      for (let i = 2; i < 33; i++) {
        if (
          top > this.getscrolltop('a' + i) - height + 200 &&
          top < this.getscrolltop('a' + i)
        ) {
          this.ani['a' + i] = true
        }
      }
      if (
        top > this.getscrolltop('n2') - height + 200 &&
        top < this.getscrolltop('n2')
      ) {
        if (this.$refs.swiper3) {
          this.$refs.swiper3.startani1()
        }
      }
      if (
        top > this.getscrolltop('s4') - height &&
        top < this.getscrolltop('s4') - 300
      ) {
        if (this.$refs.swiper3) {
          this.$refs.swiper3.startani2()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.subscript {
  font-size: 10px;
  vertical-align: top;
}
.quicknav {
  position: fixed;
  left: 0;
  top: 30vh;
  color: #fff;
  z-index: 100;
  .qnlist {
    padding-left: 40px;
    position: relative;
    cursor: pointer;
    width: 150px;
    height: 30px;
  }
  .qnlist::before {
    position: absolute;
    content: '';
    width: 15px;
    height: 0;
    border-top: 1px solid #666;
    top: 10px;
    left: 15px;
  }
  .qnactive::before {
    position: absolute;
    content: '';
    width: 30px;
    height: 0;
    border-top: 1px solid #fff;
    top: 10px;
    left: 0;
  }
}
.page {
  position: relative;
  background-color: #000;
  .btn {
    cursor: pointer;
    margin-top: 20px;
  }
  .pic {
    font-size: 0;
  }
  .lisablack {
    background-color: #000;
    // height: 8vw;
    color: #fff;
    text-align: center;
    // padding-top: 4vw;
  }
  .title {
    margin-bottom: 26px;
  }
  .content {
    line-height: 24px;
  }
  .content1 {
    line-height: 20px;
  }
  .text {
    position: absolute;
    z-index: 1;
    color: #fff;
  }
  .t1 {
    text-align: center;
    left: 0;
    top: 0;
    margin: 160px auto;
    right: 0;
    .t1_1 {
      margin-bottom: 5px;
    }
    .t1_2 {
      margin-bottom: 15px;
    }
  }
  .t1a {
    display: flex;
    display: -webkit-flex;
    justify-content: space-around;
    bottom: 80px;
    margin: 0 auto;
    left: 0;
    right: 0;
    text-align: center;
    width: 70%;
  }
  .t2 {
    left: 18vw;
    top: 9vw;
  }
  .t4 {
    left: 12vw;
    top: 15vw;
    width: 400px;
    .t4_2 {
      text-align: justify;
    }
  }
  .t5 {
    left: 12vw;
    top: 15vw;
    width: 400px;
    text-align: justify;
    .t5_1 {
      margin-bottom: 10px;
    }
    .t5_2 {
      margin-bottom: 20px;
    }
  }
  .t6 {
    top: 22.8vw;
    width: 100%;
    text-align: center;
  }
  .t6a {
    width: 100%;
    text-align: center;
    bottom: 2vw;
  }
  .normalt {
    top: 4vw;
    width: 100%;
    text-align: center;
  }
  .t7 {
    left: 7vw;
    top: 11vw;
    right: 17vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    .t7_left {
      width: 400px;
      text-align: justify;
      padding-top: 2vw;
    }
    .t7_1 {
      margin-bottom: 10px;
    }
    .t7_2 {
      margin-bottom: 20px;
    }
    .t7_3 {
      margin-bottom: 40px;
    }
  }
  .t7a {
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 3vw;
    font-size: 10px;
    text-align: center;
    color: @colorgray;
  }
  .t8 {
    background-color: #000;
    color: #fff;
    text-align: center;
    padding: 4vw 0;
    .t8a {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      width: 60%;
      margin: 80px auto 0;
      img {
        width: 50px;
        margin-bottom: 10px;
      }
      .t8a_1 {
        margin-bottom: 50px;
        height: 90px;
      }
    }
  }
  .t9a {
    width: 100%;
    text-align: center;
    bottom: 5vw;
  }
  .t11 {
    left: 7vw;
    top: 10vw;
  }
  .t12 {
    display: flex;
    display: -webkit-flex;
    left: 19.5vw;
    right: 23vw;
    justify-content: space-between;
    bottom: 7.5vw;
    .t12_2 {
      margin-right: 3vw;
    }
  }
  .t24p {
    padding: 2vw 18vw;
  }
  .t24 {
    margin-top: 3vw;
    .feature {
      width: 80%;
      margin: 0 auto;
      border-top: 1px solid #333;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      padding: 2vw 0 2vw 6vw;
      box-sizing: border-box;
      .featureitem {
        flex: 1;
        text-align: left;
        line-height: 24px;
        .subscript {
          display: inline-block;
          position: relative;
          top: -2px;
          transform: scale(0.8);
        }
        .fs_tiny {
          margin-bottom: 20px;
        }
      }
    }
    .csenv {
      text-align: center;
      font-size: 14px;
      color: #999;
    }
  }
}
.p24 {
  background: url(/static/img/p24.jpg) no-repeat;
  background-size: cover;
  color: #fff;
  padding-bottom: 2vw;
  .title {
    padding-top: 4vw;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/en/product.vue